import axios from "axios";

export const ApiClient = axios.create({
  timeout: 180000,
  headers: {
    WebRequest: 1,
    "Content-Type": "application/json; charset=UTF-8",
  },
  transformRequest: [
    (data) => {
      if (typeof data === "undefined") return null;
      let form = Object.entries(data).reduce(function (
        searchParams,
        [key, value]
      ) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            let val = item.toString();
            if (typeof item === "object") {
              val = item ? JSON.stringify(item) : "";
            }
            if (item instanceof File) {
              searchParams.append("files[]", item, item.name);
            } else {
              searchParams.append(key + "[]", val);
            }
          });
        } else if (typeof value === "object") {
          let val = value ? JSON.stringify(value) : "";
          searchParams.append(key, val);
        } else {
          searchParams.append(key, value.toString());
        }
        return searchParams;
      },
      new FormData());
      form.append("_data_", JSON.stringify(data));
      return form;
    },
  ],
});
